// Layout.js
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./SideBar";
import TopBar from "./TopBar";

const DashboardLayout = () => {
    const [isOpen, setIsOpen] = useState(false);        // Sidebar open (mobile)
    const [collapsed, setCollapsed] = useState(false);  // Sidebar collapsed (desktop)
    const [theme, setTheme] = useState("dark");         // Light/Dark theme

    useEffect(() => {
        document.documentElement.classList.toggle("dark", theme === "dark");
    }, [theme]);

    const toggleTheme = () => setTheme((prev) => (prev === "dark" ? "light" : "dark"));
    const toggleCollapsed = () => setCollapsed((prev) => !prev);

    return (
        <div className="flex min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white">
            <Sidebar
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                collapsed={collapsed}
                toggleCollapsed={toggleCollapsed}
                theme={theme}
                toggleTheme={toggleTheme}
            />

            <div className="flex-1 flex flex-col min-h-screen">
                <TopBar
                    onToggleSidebar={() => setIsOpen((prev) => !prev)}
                    theme={theme}
                    toggleTheme={toggleTheme}
                />

                <main className=" md:pl-72 p-4 mt-5 transition-all">
                    <Outlet/>
                </main>
            </div>

            {/* Mobile overlay when sidebar is open */}
            {isOpen && (
                <div
                    onClick={() => setIsOpen(false)}
                    className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden transition-opacity duration-300"
                />
            )}
        </div>
    );
};

export default DashboardLayout;
